export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-treehouse-9a4b3cc7c905d384ad50679757bfcaf1.svg";